<script setup>
import WhatsAppCampaignCard from 'dashboard/components-next/Campaigns/CampaignCard/WhatsAppCampaignCard.vue';

defineProps({
  campaigns: {
    type: Array,
    required: true,
  },
});

const emit = defineEmits(['open', 'delete']);
</script>

<template>
  <div class="flex flex-col gap-4">
    <WhatsAppCampaignCard
      v-for="campaign in campaigns"
      :key="campaign.id"
      :campaign="campaign"
      @open="emit('open', campaign)"
      @delete="emit('delete', campaign)"
    />
  </div>
</template>
